// src/data/weather.ts — Climas Fase 4
export type WeatherDef = {
  id: string;
  name: string;
  description: string;
  duration: number;
  effects: { element?: string; damageMult?: number; accMod?: number; heal?: number };
};

export const WEATHERS: Record<string, WeatherDef> = {
  despejado: { id:'despejado', name:'Cielo Despejado', description:'Sin efectos.', duration: 99, effects:{} },
  lluvia: { id:'lluvia', name:'Lluvia', description:'Potencia aqua +15%, cura leve aqua.', duration:4, effects:{ element:'aqua', damageMult:1.15 } },
  tormenta: { id:'tormenta', name:'Tormenta', description:'Potencia astra +15%, precisa -10% general.', duration:4, effects:{ element:'astra', damageMult:1.15, accMod:-0.10 } },
  neblina: { id:'neblina', name:'Neblina', description:'Precisión -15% general.', duration:4, effects:{ accMod:-0.15 } },
  sequia: { id:'sequia', name:'Sequía', description:'Potencia ignis +15%, debilita aqua.', duration:4, effects:{ element:'ignis', damageMult:1.15 } },
  nevada: { id:'nevada', name:'Nevada', description:'Potencia aero/hielo, cura agua.', duration:4, effects:{ element:'aero', damageMult:1.15 } },
};

export function getWeather(id:string): WeatherDef | undefined { return WEATHERS[id]; }
